import { useQuery } from '@tanstack/react-query';
import ApiService from '../../ApiService';

const fetchData = async () => {
    const { data } = await ApiService.getDspAudienceSources();
    return data;
};

const useDspAudienceSourceListQuery = () => {
    return useQuery({
        queryKey: ['dspAudienceSourceList'],
        queryFn: () => fetchData(),
        staleTime: Infinity,
        enabled: false,
    });
};

export { useDspAudienceSourceListQuery };
